import React from 'react';
import styled from 'styled-components';
import { relativeAgo } from './commons';

export default function LastCrawledChip({ createDate, className }) {
    return (
        <ChipWrap className={className}>
            <Chip>Last crawled: {relativeAgo(createDate)}</Chip>
            <Popover>
                <PopoverIntro>
                    This URL was not touched in the workspace's most recent crawl. Common reasons:
                </PopoverIntro>
                <PopoverList>
                    <li>May be blocked by <code>robots.txt</code></li>
                    <li>May be excluded by the workspace's crawl configuration</li>
                    <li>The crawl may have hit its page limit before reaching this URL</li>
                    <li>May be an orphan page — no internal links, not in the sitemap</li>
                </PopoverList>
            </Popover>
        </ChipWrap>
    );
}

const ChipWrap = styled.span`
    position: relative;
    display: inline-flex;
    cursor: help;
    &:hover > div,
    &:focus-within > div { opacity: 1; }
`;

const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 20px;
    background: #fef3c7;
    color: #78350f;
    border: 1px solid #fbbf24;
    white-space: nowrap;
`;

const Popover = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    width: 280px;
    background: #1e293b;
    padding: 12px 14px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.25);
    pointer-events: none;
    opacity: 0;
    transition: opacity 100ms;
    text-align: left;
    z-index: 20;
    &::before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-bottom-color: #1e293b;
    }
`;

const PopoverIntro = styled.div`
    display: block;
    font-size: 0.72rem;
    color: #f1f5f9;
    line-height: 1.5;
    margin-bottom: 8px;
`;

const PopoverList = styled.ul`
    margin: 0;
    padding-left: 18px;
    font-size: 0.7rem;
    color: #e2e8f0;
    line-height: 1.5;
    & code {
        background: rgba(255,255,255,0.08);
        padding: 0 4px;
        border-radius: 3px;
        font-size: 0.66rem;
    }
`;
